<template>
	<button class="v-button" :type="type">
    <div class="v-button-before">
			<slot name="before" v-if="'before' in $slots"/>
      <v-icon :type="iconBefore" v-else-if="iconBefore"/>
		</div>
    <div class="v-button-inner">
		  <slot/>
    </div>
		<div class="v-button-after">
      <slot name="after" v-if="'after' in $slots"/>
      <v-icon :type="iconAfter" v-else-if="iconAfter"/>
		</div>
	</button>
</template>

<script>
export default {
  props: {
    type: {
      default: null
    },
    iconBefore: {
      default: null
    },
    iconAfter: {
      default: null
    }
  },
  mounted() {
    this.$bindEvents(this.$el);
  }
};
</script>

<style lang="less">
.v-button {
  outline: none;
  cursor: pointer;
  font-size: 14px;
  color: #333333;
  padding: 0px 15px;
  line-height: 30px;
  border-radius: 2px;
  white-space: nowrap;
  display: inline-flex;
  box-sizing: border-box;
  vertical-align: middle;
  justify-content: center;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  transition: 300ms;
  &:not([disabled]) {
    &:hover {
      color: #41b883;
      border-color: #41b883;
    }
    &:active {
      color: #219863;
      border-color: #219863;
      transition: 100ms;
      transform: scale(0.94);
    }
  }
  &[type="dashed"] {
    color: #666666;
    border-style: dashed;
    &:not([disabled]) {
      &:hover {
        color: #41b883;
        border-color: #41b883;
      }
      &:active {
        color: #219863;
        border-color: #219863;
      }
    }
  }
  &[type="primary"] {
    color: #ffffff;
    border-color: #41b883;
    background-color: #41b883;
    &:not([disabled]) {
      &:hover {
        color: #eeeeee;
        border-color: #31a873;
        background-color: #31a873;
      }
      &:active {
        color: #eeeeee;
        border-color: #219863;
        background-color: #219863;
      }
    }
  }
  &[type="text"] {
    border: none;
    padding: 0px;
    color: #41b883;
    line-height: 18px;
    border-color: transparent;
    background-color: transparent;
    &:not([disabled]) {
      &:hover {
        color: #31a873;
      }
      &:active {
        color: #219863;
      }
    }
  }
  &[disabled] {
    cursor: no-drop;
    filter: grayscale(100%) brightness(90%);
  }
}
</style>





// WEBPACK FOOTER //
// src/vue-ext/components/button.vue